module.exports = __webpack_public_path__ + "static/media/push.68bae7a6.svg";